import { isObjectEmpty, lowerCaseFirstLetter } from './MiscUtils';

export const shallowValidationCheck = (validationObj: any) => {
  let isValid = true;
  if (validationObj != null && !isObjectEmpty(validationObj)) {
    Object.keys(validationObj).forEach(key => {
      const field = validationObj[key];
      if (field && !isObjectEmpty(field)) {
        isValid = false;
      }
    })
  }
  return isValid;
}

const alertKeys = [ "uniqueness", "effectiveDates", "duplicates", "dateRange", "duplication"]

export class ValidationUtils {

  static isValid(validationObject: any) {
    return shallowValidationCheck(validationObject);
  }

  static hasValidation(validationObject: any, fieldName: string) {
    if (validationObject != null && fieldName != null) {
      return (fieldName in validationObject && validationObject[fieldName] != null);
    } else {
      return false;
    }
  }

  static hasValidationError(validationObject: any, fieldName: string) {
    if (validationObject.errors !== (null || undefined)) {
      return (fieldName in validationObject.errors && validationObject.errors[fieldName] !== (null || undefined));
    } else {
      return false;
    }
  }

  static hasValidationWarning(validationObject: any, fieldName: string) {
    if (validationObject.warnings !== (null || undefined)) {
      return (fieldName in validationObject.warnings && validationObject.warnings[fieldName] !== (null || undefined));
    } else {
      return false;
    }
  }

  static getValidationText(validationObject: any, fieldName: string) {
    let result;
    if (this.hasValidation(validationObject, fieldName)) {
      result = validationObject[fieldName].text;
    };
    return result;
  }

  static getValidationErrorText(validationObject: any, fieldName: string) {
    let result;
    if (this.hasValidationError(validationObject, fieldName)) {
      result = validationObject.errors[fieldName].text;
    };
    return result;
  }

  static getValidationWarningText(validationObject: any, fieldName: string) {
    let result;
    if (this.hasValidationWarning(validationObject, fieldName)) {
      result = validationObject.warnings[fieldName].text;
    };
    return result;
  }

  static getValidationTextFromMessagesArray(validationErrors: any, fieldName: string) {
    let result;
    if (validationErrors && validationErrors.length !== 0) {
      const index = validationErrors.findIndex((item: {field: string, message: string}) => item.field === fieldName)

      if(index !== -1) {
        result = validationErrors[index].message
      }
    };
    return result;
  }

  static formatMarkupValidation = (errors: any | undefined) => {
    if (!errors) return null;
    let errorsObj: any = {};
    Object.keys(errors).forEach((key: string) => {
      errorsObj[lowerCaseFirstLetter(key)] = { text: errors[key][0] };
    });
    return errorsObj;
  }

  static hasAlertMessages = (validation?: any) => {
    return validation && Object.keys(validation).some((key: string) => validation[key] && alertKeys.includes(key))
  }

  static getAlertKeys = (validation?: any) => validation && Object.keys(validation).filter((key: string) => alertKeys.includes(key) && validation[key])

}
